
import { defineComponent } from "vue";
import getEntityTranslation from "../../utils/get-entity-translation";

export default defineComponent({
    name: "TranslationComponent",
    props: {
        data: {
            type: Object,
            required: true,
        },
        property: {
            type: String,
            required: true,
        },
    },
    computed: {
        translation() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return getEntityTranslation<any>(this.data, this.property);
        },
    },
});
